import React, { useState, useRef } from 'react';
import {
    Paging,
    Pager,
    FilterRow,
    Column,
    Lookup,
    Export,
    Editing,
    Scrolling,
    RequiredRule,
    SearchPanel,
    Button as ButtonGrid
}
    from 'devextreme-react/data-grid';
import { DataGrid } from 'devextreme-react';
import { useDispatch, useSelector } from 'react-redux'
import uri from '../../utils/uri';
import Title from '../../components/shared/Title';
import BlockHeader from '../../components/shared/BlockHeader';
import { store } from '../../services/store';
import { resources } from '../../data/app';
import ProductDDBComponent from '../../components/dropdown/ProductDDBComponent';
import useAuthorization from "../../hooks/useAuthorization";
import { dialogConvertProduct } from '../../store/convertProduct/convertProductDialogReducer';
import { useEffect } from 'react';
import http from '../../utils/http';
import NuevoConvertir from './NuevoConvertir';

const Convertions = (props) => {

    let dataGrid = useRef();
    const [products, setProducts] = useState([]);
    const [authorized, _, add, canConvert] = useAuthorization(resources.verConversionProducto, resources.modificarConversionProducto, resources.realizarConversiones);
    const dispatch = useDispatch();
    const openDialog = (sourceProductId, targetProductId) => dispatch(dialogConvertProduct({open : true, sourceProductId, targetProductId}));

    const onToolbarPreparing = (e) => {

        if (!add) return;

        e.toolbarOptions.items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                text: 'Agregar Conversión',
                icon: 'plus',
                type: 'default',
                stylingMode: "outlined",
                onClick: () => dataGrid.current.instance.addRow()
            }
        });
    }

    const title = 'Registro de Conversiones de Productos';


    const onInitNewRow = (e) => {
        e.data.id = 0;
    }

    useEffect(() => {
        http('catalogos/products').asGet().then(data => setProducts(data));
    }, []);

    return authorized(
        <div className="container">
            <Title title={title} />
            <BlockHeader title={title} showFavorite={true} {...props}>
            </BlockHeader>
            <NuevoConvertir />
            <DataGrid id="gridContainer"
                ref={dataGrid}
                selection={{ mode: 'single' }}
                dataSource={store({ uri: uri.productConvertions, remoteOperations: true })}
                showBorders={true}
                showRowLines={true}
                allowColumnResizing={true}
                allowColumnReordering={true}
                onToolbarPreparing={onToolbarPreparing}
                remoteOperations={true}
                onInitNewRow={onInitNewRow}
            >
                <Paging defaultPageSize={20} />
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50]}
                />
                <Scrolling mode="infinite" />
                <FilterRow visible={true} />
                <SearchPanel visible={true} width={240} placeholder="Buscar por producto A" />
                <Export enabled={true} fileName={'Gastos'} allowExportSelectedData={true} />
                <Column dataField="id" width={80} allowEditing={false} allowSearch={false} />
                <Column type="buttons" width={100} visible={canConvert}>
                    <ButtonGrid name="custom" text={'Convertir'} cssClass={'btn-convertir'} onClick={(e) => openDialog(e.row.data.sourceProductId, e.row.data.targetProductId)} />
                </Column>
                <Column dataField="sourceProductId" caption="Producto A"                  
                    editCellComponent={props => <ProductDDBComponent showPrice={true} {...props} validateQuantity={false} showStock={false} showDisponible={false} />}
                >

                    <Lookup
                        dataSource={products}
                        valueExpr="id"
                        displayExpr={item => item ? `${item.internalCode} - ${item.name}` : ''}

                    />
                    <RequiredRule />
                </Column>
                <Column dataField="sourceQuantity" caption="Cantidad A" dataType="number" width={100} alignment="right" allowSearch={false}><RequiredRule /></Column>

                <Column dataField="targetProductId" caption="Producto B" allowSearch={false}
                    editCellComponent={props => <ProductDDBComponent showPrice={true} {...props} validateQuantity={false} showStock={false} showDisponible={false} />}
                >
                    <Lookup dataSource={products}
                        valueExpr="id"
                         displayExpr={item => item ? `${item.internalCode} - ${item.name}` : ''}
                    />
                    <RequiredRule />
                </Column>
                <Column dataField="targetQuantity" caption="Cantidad B" dataType="number" width={100} alignment="right" allowSearch={false}><RequiredRule /></Column>

                <Column dataField="createAt" allowSearch={false} caption="Creado el" dataType="date" width={110} format="dd/MM/yyyy" allowEditing={false} showEditorAlways={false} />
                <Column dataField="createBy" allowSearch={false} caption="Creado por" width={100} allowEditing={false} />
                <Column dataField="modifyAt" allowSearch={false} caption="Modificado el" dataType="date" width={100} format="dd/MM/yyyy" allowEditing={false} visible={false}/>
                <Column dataField="modifyBy" allowSearch={false} caption="Modificado por" width={150} allowEditing={false} visible={false} />
                <Column type="buttons" width={50}>
                    <ButtonGrid name="delete" icon={'trash'} />
                </Column>

                <Editing
                    mode="cell"
                    allowUpdating={true}
                    allowDeleting={true}
                    useIcons={true}
                >
                    {/* <Popup title={title} showTitle={true} width={700} height={320}>
                        <ToolbarItem
                            widget="dxButton"
                            location="after"
                            options={
                                {
                                    icon: 'save',
                                    onClick: (e) => {

                                        dataGrid.current.instance.saveEditData()
                                            .then(() => {
                                                //setReloadScreen(reloadScreen + 1);
                                                //setReload(true);
                                            });
                                    }
                                }
                            }>
                        </ToolbarItem>
                    </Popup>
                    <Form>                      
                        <Item  dataField="sourceProductId" colSpan={2} editorType="dxSelectBox"
                            editorOptions={{...editorOptionsSelect}} >
                            <RequiredRule message="El campo es requerido"/>
                        </Item>                       
                        <Item dataField="sourceQuantity" colSpan={2} editorType="dxNumberBox" editorOptions={editorOptionsNumberBox}>
                            <RequiredRule message="El campo es requerido"/>
                        </Item>
                        <Item  dataField="targetProductId" colSpan={2} editorType="dxSelectBox"
                            editorOptions={editorOptionsSelect} >
                            <RequiredRule message="El campo es requerido"/>
                        </Item>     
                        <Item  dataField="targetQuantity" colSpan={2} editorType="dxNumberBox"
                            editorOptions={editorOptionsNumberBox} >
                            <RequiredRule message="El campo es requerido"/>
                        </Item>
                    </Form> */}
                </Editing>
            </DataGrid>
        </div>
    );
}

export default Convertions;
